import React, { useRef } from 'react';
import PropTypes from 'prop-types';
// import { showMenu } from 'react-contextmenu/modules/actions';

import IconMore from '../svg/IconMore';

function More({ id, size, onClick, className, style }) {
  const el = useRef();
  // const showContextMenu = (e) => { // V1 - react-contextmenu
  //   onClick(e);
  //   const p = el.current.getBoundingClientRect();
  //   let position = (e.clientX === 0 && e.clientY === 0 && el.current.MClientX) ? {x: el.current.MClientX / window[`window_zoom`], y: el.current.MClientY / window[`window_zoom`]} : {x: p.left / window[`window_zoom`], y: (p.top + p.height) / window[`window_zoom`]}
  //   showMenu({
  //     position,
  //     target: {},
  //     id: `DynamicMenu`
  //   })
  // }
  return (
    <div ref={el} id={id} className={className} style={{...style}} onClick={onClick/*showContextMenu*/} >
      <IconMore size={size} />
    </div>
  )
}

More.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default More;
